import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Actions, ActionType } from '@vendasta/platform-integrations';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlatformIntegrationsI18nModule } from '@galaxy/platform-integrations/shared';

@Component({
  selector: 'platform-integration-action-type',
  imports: [
    MatDialogActions,
    MatIconModule,
    MatDialogClose,
    MatButtonModule,
    MatCardModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatRadioModule,
    CommonModule,
    GalaxyInputModule,
    MatDividerModule,
    MatInputModule,
    MatFormFieldModule,
    GalaxyFormFieldModule,
    TranslateModule,
    MatDialogActions,
    MatIconModule,
    MatDialogClose,
    MatButtonModule,
    MatCardModule,
    MatSlideToggleModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatRadioModule,
    CommonModule,
    GalaxyInputModule,
    MatDividerModule,
    MatInputModule,
    MatFormFieldModule,
    GalaxyFormFieldModule,
    PlatformIntegrationsI18nModule,
  ],
  templateUrl: './action-type.component.html',
})
export class ActionTypeComponent {
  @Input() actions: Actions[] = [];

  protected actionType = ActionType;

  @Output() actionClicked = new EventEmitter<any>();

  onActionClick(action: ActionType) {
    this.actionClicked.emit(action);
  }
}
